import ScamsListSender from './ScamsListSender.jsx';

export default ScamsListSender;